export default function Skeleton({ className = "h-4 w-40", rounded = "md", ...props }) {
  const roundedClass = rounded === "full" ? "rounded-full" : rounded === "lg" ? "rounded-lg" : rounded === "sm" ? "rounded-sm" : "rounded-md";
  return <div aria-hidden="true" className={`skeleton ${roundedClass} ${className}`} {...props} />;
}
